import styled from '@emotion/styled';
import { DatePicker } from 'antd';

export const FullWidthDatePicker = styled(DatePicker)`
  width: 100%;
`;
